import type { CompanyLegalForm } from "@component/SmeLoan/LeadForm/types";
import type { CommonOptions } from "bm-ui-kit";

export const COMPANY_LEGAL_FORMS: CommonOptions<CompanyLegalForm> = [
	{
		value: "KFT",
		label: "Kft.",
	},
	{
		value: "BT",
		label: "Bt.",
	},
	{
		value: "ZRT",
		label: "Zrt.",
	},
	{
		value: "BT_KATA",
		label: "Bt.(KATA)",
	},
	{
		value: "NYRT",
		label: "Nyrt.",
	},
	{
		value: "KKT",
		label: "Kkt.",
	},
	{
		value: "KFC",
		label: "Egyéni cég",
	},
	{
		value: "OTHER",
		label: "Egyéb vállalkozás",
	},
	{
		value: "COOPERATIVE",
		label: "Szövetkezet",
	},
	{
		value: "SELF_EMPLOYED",
		label: "Egyéni vállalkozó",
	},
	{
		value: "SELF_EMPLOYED_KATA",
		label: "Egyéni vállalkozó (KATA)",
	},
	{
		value: "PRIMARY_PRODUCER",
		label: "Őstermelő",
	},
	{
		value: "FAMILY_FARM",
		label: "Családi gazdálkodó",
	},
];
